import accepted from 'src/assets/images/orderStatuses/accepted.svg'
import assigned from 'src/assets/images/orderStatuses/assigned.svg'
import forRevision from 'src/assets/images/orderStatuses/clarify_request.svg'
import duplicate from 'src/assets/images/orderStatuses/duplicate.svg'
import incomplete from 'src/assets/images/orderStatuses/incomplete.svg'
import installation from 'src/assets/images/orderStatuses/installation.svg'
import installed from 'src/assets/images/orderStatuses/installed.svg'
import created from 'src/assets/images/orderStatuses/new.svg'
import uploadByAdmin from 'src/assets/images/orderStatuses/uploadByAdmin.svg'
import closed from 'src/assets/images/reportStatuses/closed.svg'
import dataChecking from 'src/assets/images/reportStatuses/dataChecking.svg'
import dataCheckFinished from 'src/assets/images/reportStatuses/dataCheckingFinished.svg'
import dataClarifying from 'src/assets/images/reportStatuses/dataClarifying.svg'
import formed from 'src/assets/images/reportStatuses/formed.svg'

export const mapRequestsStatuses = {
  1: {
    id: 1, // created
    name: 'Создана',
    imageSrc: created,
  },
  2: {
    id: 2, // assigned
    name: 'Назначена',
    imageSrc: assigned,
  },
  4: {
    id: 4, // accepted
    name: 'Принята',
    imageSrc: accepted,
  },
  5: {
    id: 5, // working
    name: 'Установка',
    imageSrc: installation,
  },
  6: {
    id: 6, // installed
    name: 'Установлено',
    imageSrc: installed,
  },
  7: {
    id: 7, // impossible
    name: 'Невозможно',
    imageSrc: incomplete,
  },
  9: {
    id: 9, // loadedByOperator
    name: 'Добавлена администратором',
    imageSrc: uploadByAdmin,
  },
  10: {
    id: 10, // duplicate
    name: 'Дубликат',
    imageSrc: duplicate,
  },
  11: {
    id: 11, // uncompleted
    name: 'На доработку',
    imageSrc: forRevision,
  },
  12: {
    id: 12, // reporting
    name: 'Добавлена в отчет',
    imageSrc: formed,
  },
  13: {
    id: 13, // dataChecking
    name: 'Проверка данных',
    imageSrc: dataChecking,
  },
  14: {
    id: 14, // clarifying
    name: 'Уточнение данных',
    imageSrc: dataClarifying,
  },
  15: {
    id: 15, // reported
    name: 'Проверка завершена',
    imageSrc: dataCheckFinished,
  },
  16: {
    id: 16, // closed
    name: 'Завершена',
    imageSrc: closed,
  },
}
